import React from "react";
import App from "./../app.jsx";
import { Navigate, Outlet, useParams } from "react-router-dom";
import Home from "../pages/dashboard/dashboard.js";
import ExtraError from "./../pages/extra/extra-error.js";
import Login from "./../pages/user/login.js";
import PrivateRoute from "./PrivateRoute";
import ManageStaff from "../pages/staff/manageStaff.js";
import AddStaff from "../pages/staff/AddStaff.js";
import UpdateStaff from "../pages/staff/updateStaff.js";
import UpdatePassword from "../pages/staff/UpdatePassword.jsx";
import CreateItem from "../pages/items/createItem.jsx";
import ManageItems from "../pages/items/ManageItems.js";
import ManageCategories from "../pages/categories/manageCategories.jsx";
import AddCategory from "../pages/categories/addCategory/addCategory.js";
import AddMenu from "../pages/Menu/addMenu.js";
import ManageMenus from "../pages/Menu/manageMenu.js";
import UpdateMenu from "../pages/Menu/updateMenu.js";
import ManageDiscount from "../pages/discount/manageDiscount.js";
import UpdateCategory from "../pages/categories/updateCategory.js";
import AddCustomer from "../pages/customer/customer/addCustomer.js";
import ManageCustomers from "../pages/customer/customer/manageCustomer.jsx";
import ManageCustomersGroup from "../pages/customer/GroupTypes/manageCustomerGroup.jsx";
import AddModifierGroup from "../pages/modifiers/addModifierGroup.js";
import ManageModifierGroups from "../pages/modifiers/manageModifireGroups.jsx";
import ManageModifiers from "../pages/modifiers/manageModifiers.jsx";
import UpdateCustomer from "../pages/customer/customer/updateCustomer.js";
import UpdateModifierGroup from "../pages/modifiers/updateModifierGroup.js";
import AddDiscount from "../pages/discount/addDiscount.jsx";
import UpdateItem from "../pages/items/updateItem.jsx";
import UpdateDiscount from "../pages/discount/updateDiscount.js";
import AddRole from "../pages/role/addRole.js";
import ManageRole from "../pages/role/manageRole.js";
import UpdateRole from "../pages/role/updateRole.js";
import Profile from "../pages/profile/profile.js";
import VerifyCompanyEmail from "../pages/profile/VerifyCompanyEmail.jsx";
import Settings from "../pages/setting/setting.js";
import PromotionBanners from "../pages/setting/promotionBanners.jsx";
import OnlineOrderingBanners from "../pages/setting/onlineOrderingBanners.jsx";
import ManageCampaigns from "../pages/customer/campaigns/manageCampaigns.jsx";
import ManageOrder from "../pages/order/manageOrder.js";
import ManageDevices from "../pages/devices/manageDevices.js";
import PrintingReceipts from "../pages/printing Receipts/printingReceipts.js";
import PaymentMethods from "../pages/paymentMethod/paymentMethod.js";
import ManageTwilioGateway from "../pages/messaging/manageTwilioGateway.jsx";
import EmailSenderSettingsPage from "../pages/messaging/emailSenderSettings.jsx";
import SmsTopUps from "../pages/messaging/smsTopUps.jsx";
import SmsTopUpComplete from "../pages/messaging/smsTopUpComplete.jsx";
import ServiceTime from "../pages/tableManagement/serviceTime.js";
import ManageReservations from "../pages/tableManagement/reservation.jsx";
import ManageSpecialItems from "../pages/tableManagement/specialItems.jsx";
import ManageMenuPresets from "../pages/tableManagement/menuPresets.jsx";
import ManageAdvanceDeposit from "../pages/tableManagement/manageAdvanceDeposit.jsx";
import AddAdvanceDeposit from "../pages/tableManagement/addAdvanceDeposit.jsx";
import UpdateAdvanceDeposit from "../pages/tableManagement/updateAdvanceDeposit.jsx";
import ManageDiningAreas from "../pages/tableManagement/diningArea/DiningArea.jsx";
import AddDiningArea from "../pages/tableManagement/diningArea/addDiningArea.jsx";
import UpdateDiningArea from "../pages/tableManagement/diningArea/updateDiningArea.jsx";
import ManagePettyCash from "../pages/PettyCash/managePettyCash.jsx";
import PricingSubscriptions from "../pages/setting/Pricing&Subscriptions.js";
import SubscriptionInvoices from "../pages/subscription/subscriptionInvoices.jsx";
import SubscriptionInvoiceComplete from "../pages/subscription/subscriptionInvoiceComplete.jsx";
import ManageCategoryDepartments from "../pages/categoryDepartment/manageCategoryDepartment.jsx";
import ManageReportingCategory from "../pages/reportingCategory/manageReportingCategoery.jsx";
import ManageVoucher from "../pages/voucher/manageVoucher.js";
import ManageCateringServices from "../pages/catering/manageCateringServices.jsx";
import ManageMarketingGroups from "../pages/marketing/manageMarketingGroups.jsx";
import CreateMarketingGroup from "../pages/marketing/createMarketingGroup.jsx";
import UpdateMarketingGroup from "../pages/marketing/updateMarketingGroup.jsx";
import ManageSmsPresets from "../pages/marketing/manageSmsPresets.jsx";
import ManageEmailPresets from "../pages/marketing/manageEmailPresets.jsx";
import CreateEmailPreset from "../pages/marketing/createEmailPreset.jsx";
import UpdateEmailPreset from "../pages/marketing/updateEmailPreset.jsx";
import MarketingSettingsPage from "../pages/marketing/marketingSettings.jsx";
import AddVoucher from "../pages/voucher/addVoucher.jsx";
import UpdateVoucher from "../pages/voucher/updateVoucher.js";
import DashboardV3 from "../pages/dashboard/dashboard-v3.js";
import DashboardV2 from "../pages/dashboard/dashboard-v2.js";
import DashboardV1 from "../pages/dashboard/dashboard-v1.js";
import OrderDetailsView from "../pages/order/orderDetailView.js";
import CustomerReport from "../pages/report/customerReport.jsx";
import AllStaffShiftReport from "../pages/report/AllStaffShiftReport.jsx";
import StaffWorkReport from "../pages/report/StaffWorkReport.jsx";
import SalesBreakdownByTime from "../pages/report/salesBreakdownByTime.jsx";
import SalesByProducts from "../pages/report/salesByProducts.jsx";
import DealPerformanceReport from "../pages/report/DealPerformanceReport.jsx";
import TableSpentReport from "../pages/report/TableSpentReport.jsx";
import TableCoverReport from "../pages/report/TableCoverReport.jsx";
import ZReport from "../pages/report/zReport.jsx";
import CashReport from "../pages/report/cashReport.jsx";
import StaffShiftReport from "../pages/staff/StaffShiftReport.jsx";
import StaffPayout from "../pages/staff/StaffPayout.jsx";
import ManageScheduleRoster from "../pages/staff/manageScheduleRoster.jsx";
import AddSupplier from "../pages/supplier/addSupplier.js";
import ManageSuppliers from "../pages/supplier/manageSupplier.jsx";
import UpdateSupplier from "../pages/supplier/updateSupplier.js";
import BulkEditItems from "../pages/items/bulkEditItem.js";
import AutoLogin from "../pages/user/AutoLogin.jsx";
import ManageDeals from "../pages/deal/ManageDeals.js";
import CreateDeal from "../pages/deal/createDeal.jsx";
import UpdateDeal from "../pages/deal/updateDeal.jsx";
// Loyalty Components
import RewardsManagement from "../pages/loyalty/rewards.js";
import LoyaltyRulesManagement from "../pages/loyalty/rules.js";
import CreateReward from "../pages/loyalty/createReward.jsx";
import UpdateReward from "../pages/loyalty/updateReward.jsx";
import LoyaltyAnalytics from "../pages/loyalty/analytics.js";

/** Redirect legacy weekly schedule URLs to Schedule (weekly UI deprecated). */
function RedirectStaffScheduleToRoster() {
  const { UserName } = useParams();
  return <Navigate to={`/staff/manageScheduleRoster/${UserName}`} replace />;
}

/** Staff Leave module deprecated — use Schedule (Mark Leave on roster). */
function RedirectStaffLeaveToManageStaff() {
  return <Navigate to="/staff/manageStaff" replace />;
}

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <DashboardV1 /> }, // Root path shows dashboard
          { path: "dashboard", element: <DashboardV1 /> },
          { path: "dashboard/v3", element: <Home /> },
          { path: "dashboard/v2", element: <DashboardV2 /> },
          { path: "dashboard/v1", element: <DashboardV3 /> },
        ],
      },
      {
        path: "user/*",
        element: <Outlet />,
        children: [
          { path: "login", element: <Login /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "auto-login",
        element: <AutoLogin />,
      },
      {
        path: "verify-company-email",
        element: <VerifyCompanyEmail />,
      },
      {
        path: "staff/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageStaff", element: <ManageStaff /> },
          { path: "AddStaff", element: <AddStaff /> },
          { path: "updateStaff/:UserName", element: <UpdateStaff /> },
          { path: "updatePassword/:UserName", element: <UpdatePassword /> },
          { path: "weeklySchedule/:UserName", element: <RedirectStaffScheduleToRoster /> },
          { path: "staffSchedule/:UserName", element: <RedirectStaffScheduleToRoster /> },
          { path: "manageScheduleRoster", element: <ManageScheduleRoster /> },
          { path: "manageScheduleRoster/:UserName", element: <ManageScheduleRoster /> },
          { path: "StaffShiftReport/:UserName", element: <StaffShiftReport /> },
          { path: "payout/:UserName", element: <StaffPayout /> },
          { path: "staffLeave", element: <RedirectStaffLeaveToManageStaff /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "items/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageItems", element: <ManageItems /> },
          { path: "manageItems/:RootCat_ID", element: <ManageItems /> },
          // Bulk Edit Route - ADD THIS
          { path: "bulkEditItems", element: <BulkEditItems /> },
          // With IsCombo parameter (Combo route - commented out)
          // { path: "createItem/:ProductType/:IsCombo", element: <CreateItem /> },
          // Without IsCombo parameter
          { path: "createItem/:ProductType", element: <CreateItem /> },
          { path: "updateItem/:itemId", element: <UpdateItem /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "deal/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageDeals", element: <ManageDeals /> },
          { path: "createDeal", element: <CreateDeal /> },
          { path: "updateDeal/:dealId", element: <UpdateDeal /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "menu/*",
        element: <PrivateRoute />,
        children: [
          { path: "addMenu", element: <AddMenu /> },
          { path: "manageMenu", element: <ManageMenus /> },
          { path: "updateMenu/:menuId", element: <UpdateMenu /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "role/*",
        element: <PrivateRoute />,
        children: [
          { path: "addrole", element: <AddRole /> },
          { path: "manageRole", element: <ManageRole /> },
          { path: "updateRole/:roleId", element: <UpdateRole /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "tableManagement/*",
        element: <PrivateRoute />,
        children: [
          { path: "serviceTime", element: <ServiceTime /> },
          { path: "reservation", element: <ManageReservations /> },
          { path: "specialItems", element: <ManageSpecialItems /> },
          { path: "menuPresets", element: <ManageMenuPresets /> },
          { path: "manageAdvanceDeposit", element: <ManageAdvanceDeposit /> },
          { path: "addAdvanceDeposit", element: <AddAdvanceDeposit /> },
          { path: "updateAdvanceDeposit/:id", element: <UpdateAdvanceDeposit /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "pettyCash/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePettyCash", element: <ManagePettyCash /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "diningAreas/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <ManageDiningAreas /> },
          { path: "addDiningArea", element: <AddDiningArea /> },
          { path: "updateDiningArea/:sA_ID", element: <UpdateDiningArea /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "profile", element: <Profile /> },
          { path: "paymentMethod", element: <PaymentMethods /> },
          { path: "messaging/twilioSettings", element: <ManageTwilioGateway /> },
          { path: "messaging/smsTopUps", element: <SmsTopUps /> },
          { path: "messaging/smsTopUps/complete", element: <SmsTopUpComplete /> },
          { path: "messaging/emailSenderSettings", element: <EmailSenderSettingsPage /> },
          { path: "manageDevices", element: <ManageDevices /> },
          { path: "customer/addCustomer", element: <AddCustomer /> },
          { path: "customer/manageCustomer", element: <ManageCustomers /> },
          {
            path: "customerGroup/manageCustomerGroup",
            element: <ManageCustomersGroup />,
          },
          {
            path: "customer/updateCustomer/:cusID",
            element: <UpdateCustomer />,
          },
          { path: "campaigns/manageCampaigns", element: <ManageCampaigns /> },
          // Loyalty Routes
          { path: "loyalty/rules", element: <LoyaltyRulesManagement /> },
          { path: "loyalty/rewards", element: <RewardsManagement /> },
          { path: "loyalty/createReward", element: <CreateReward /> },
          { path: "loyalty/updateReward/:rewardId", element: <UpdateReward /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "manageCategoryDepartments",
            element: <ManageCategoryDepartments />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "manageReportingCategory",
            element: <ManageReportingCategory />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "setting", element: <Settings /> },
          { path: "setting/promotion-banners", element: <PromotionBanners /> },
          { path: "setting/online-ordering-banners", element: <OnlineOrderingBanners /> },
          {
            path: "setting/Pricing&Subscriptions",
            element: <PricingSubscriptions />,
          },
          { path: "subscription-invoices", element: <SubscriptionInvoices /> },
          {
            path: "subscription-invoices/complete",
            element: <SubscriptionInvoiceComplete />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "printingReceipts", element: <PrintingReceipts /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Order/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageOrder", element: <ManageOrder /> },
          { path: "orderDetails/:orderId", element: <OrderDetailsView /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "discount/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageDiscount", element: <ManageDiscount /> },
          { path: "adddiscount", element: <AddDiscount /> },
          { path: "updatediscount/:discountId", element: <UpdateDiscount /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Supplier/*",
        element: <PrivateRoute />,
        children: [
          { path: "addSupplier", element: <AddSupplier /> },
          { path: "manageSupplier", element: <ManageSuppliers /> },
          {
            path: "updateSupplier/:sID",
            element: <UpdateSupplier />,
          },
        ],
      },

      {
        path: "voucher/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageVoucher", element: <ManageVoucher /> },
          { path: "addVoucher", element: <AddVoucher /> },
          { path: "updateVoucher/:voucherId", element: <UpdateVoucher /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "catering/*",
        element: <PrivateRoute />,
        children: [
          { path: "services/manageServices", element: <ManageCateringServices /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketing/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageMarketingGroups", element: <ManageMarketingGroups /> },
          { path: "addMarketingGroup", element: <CreateMarketingGroup /> },
          { path: "updateMarketingGroup/:groupId", element: <UpdateMarketingGroup /> },
          { path: "manageSmsPresets", element: <ManageSmsPresets /> },
          { path: "manageEmailPresets", element: <ManageEmailPresets /> },
          { path: "addEmailPreset", element: <CreateEmailPreset /> },
          { path: "updateEmailPreset/:presetId", element: <UpdateEmailPreset /> },
          { path: "marketingSettings", element: <MarketingSettingsPage /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "modifiers/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageModifierGroups", element: <ManageModifierGroups /> },
          { path: "manageModifiers", element: <ManageModifiers /> },
          { path: "addModifierGroup", element: <AddModifierGroup /> },
          {
            path: "updateModifierGroup/:mGID",
            element: <UpdateModifierGroup />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "categories/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageCategories", element: <ManageCategories /> },
          { path: "createItem", element: <CreateItem /> },
          { path: "addCategory", element: <AddCategory /> },
          { path: "addCategory/:rootCatID", element: <AddCategory /> },
          { path: "updateCategory/:rootCatID", element: <UpdateCategory /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "report/*",
        element: <PrivateRoute />,
        children: [
          { path: "customerReport", element: <CustomerReport /> },
          { path: "AllStaffShiftReport", element: <AllStaffShiftReport /> },
          { path: "staffWorkReport", element: <StaffWorkReport /> },
          { path: "tableSpent", element: <TableSpentReport /> },
          { path: "tableCover", element: <TableCoverReport /> },
          { path: "salesBreakdownByTime", element: <SalesBreakdownByTime /> },
          { path: "salesByProducts", element: <SalesByProducts /> },
          { path: "dealPerformance", element: <DealPerformanceReport /> },
          { path: "zReport", element: <ZReport /> },
          { path: "cashReport", element: <CashReport /> },
          { path: "loyaltyReport", element: <LoyaltyAnalytics /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
    ],
  },
];
export default AppRoute;
